<template>
  <div class="pa-3 d-flex flex-column align-center full h-screen">
    <v-card pa-2 class="game">
      <v-toolbar color="indigo" class="mb-3" dense dark
        ><h3>Raynor</h3>
        <v-spacer></v-spacer>
        <v-btn dark text>Instruksi Game</v-btn>
      </v-toolbar>
      <v-col cols="12" md="12">
        <v-btn color="indigo" dark @click="startPlay" v-if="showPlay"
          >Mulai Game</v-btn
        >
      </v-col>
      <v-col cols="12" md="12" class="">
        <canvas id="canvas" ref="canvasRef" style="width: 100%; height: 100%" />
      </v-col>
    </v-card>
  </div>
</template>

<script>
import UnityWebgl from "unity-webgl";
export default {
  name: "raynorGame",
  data() {
    return {
      unityComponent: null,
      sendText: false,
      isPlayed: true,
      showPlay: false,
      intervalRender: null,
    };
  },
  methods: {
    configGame() {
      if (!this.unityComponent && this.isPlayed) {
        localStorage.removeItem("rendered");
        const options = {
          loaderUrl: "/Smara/Build/Smara.loader.js",
          dataUrl: "/Smara/Build/Smara.data",
          frameworkUrl: "/Smara/Build/Smara.framework.js",
          codeUrl: "/Smara/Build/Smara.wasm",
        };
        this.unityComponent = new UnityWebgl(this.$refs.canvasRef, options);
      }
    },
    startPlay() {
      this.unityComponent.send("gameManager", "StartGame", `acumalaka`);
      this.isPlayed = true;
      this.showPlay = false;
      localStorage.removeItem("rendered");
    },
    checkIsRendered() {
      this.intervalRender = setInterval(() => {
        let isRendered = localStorage.getItem("rendered");
        if (isRendered) {
          clearInterval(this.intervalRender);
          this.showPlay = true;
        }
      }, 1000);
    },
  },
  mounted() {
    this.configGame();
    this.checkIsRendered();
  },
  beforeDestroy() {
    if (this.unityComponent) {
      this.unityComponent.destroy();
      this.unityComponent = null;
    }
  },
};
</script>

<style scoped>
/* Add your styles here */
.game {
  width: max-content;
  min-width: 70%;
}
</style>
